/* WTF site-wide click tracking, 2026-10-24.
   Jeff, 4:2x PM AZ: "I need tracking code placed in all major clickable links on the website. I want to know what everyone does and their path through my site so I can know exactly what to do."

   WHAT IT DOES
   - One delegated click listener on document, capture phase, passive. It never calls preventDefault or stopPropagation and never changes navigation.
   - Finds the nearest tracked element with a selector map (MAP below). Anything else that is an <a> or <button> goes to area "other".
   - Sends each click two ways:
       (a) Shopify.analytics.publish('wtf_click', payload)    (customer events, for a future pixel)
       (b) Microsoft Clarity, when window.clarity exists:  clarity('event', 'click_' + area)
     On page load, when window.clarity exists: clarity('set', 'page_type', page_type).
   - Forwards every Shopify.analytics.publish event whose name starts with "wtf_" to clarity('event', name). The wrap is installed ONCE.
     That also forwards wtf_cf_date_pick, wtf_cf_date_complete, wtf_cf_date_blocked (assets/wtf-cancer-free-date.js), wtf_pairs_click, wtf_ff:*, wtf_mascot:*.
   - Payload: { area, label, href, page_type, product_handle }. label is short visible text or aria-label (60 chars max, emails and long digit runs removed).
     href is the path only (no query string, no hash). product_handle only on a product page.
     NEVER sent: email, name, customer id, cart contents, form values. Typed fields and the date pickers are skipped.
   - Clicks that scripts make by calling element.click() (isTrusted false) are ignored, so a sticky button that clicks the real button counts once.
   - Every step is inside try/catch. This file can never break a page.
   - Clarity itself loads from snippets/wtf-clarity.liquid, and only when the Project ID is set there. */
(function () {
  'use strict';
  try {
    if (window.__wtfClickTrack) return;
    window.__wtfClickTrack = { version: 1 };

    var MAX_LABEL = 60;
    var DUP_MS = 50;
    var internalPublish = false;
    var LABEL_MS = 400;
    var lastKey = '';
    var lastAt = 0;
    var lastCtl = null;   /* the control of the label that was just clicked */
    var lastCtlAt = 0;

    /* ---------- text helpers ---------- */
    function txt(s) {
      return String(s === null || s === undefined ? '' : s).replace(/\s+/g, ' ').trim();
    }
    function scrub(s) {
      s = txt(s);
      s = s.replace(/[^\s@]+@[^\s@]+\.[^\s@]+/g, '');
      s = s.replace(/\d[\d\s().\-+]{5,}\d/g, '#');
      s = txt(s);
      if (s.length > MAX_LABEL) s = txt(s.slice(0, MAX_LABEL));
      return s;
    }
    function defLabel(el) {
      var v = el.getAttribute && el.getAttribute('aria-label');
      if (v && txt(v)) return v;
      var t = txt(el.textContent);
      if (t) return t;
      v = el.getAttribute && el.getAttribute('title');
      if (v && txt(v)) return v;
      var img = el.querySelector ? el.querySelector('img[alt]') : null;
      if (img && txt(img.getAttribute('alt'))) return img.getAttribute('alt');
      if (el.tagName === 'INPUT' && (el.type === 'checkbox' || el.type === 'radio')) return el.value || '';
      return (el.getAttribute && (el.getAttribute('name') || el.id)) || '';
    }

    /* A facet value label, without the product count: "In stock (84) In stock (84 products)" becomes "In stock". */
    function facetLabel(el) {
      var lab = el.tagName === 'LABEL' ? el : (el.closest ? el.closest('label') : null);
      if (!lab && el.labels && el.labels[0]) lab = el.labels[0];
      if (!lab && el.id) lab = document.querySelector('label[for="' + el.id.replace(/"/g, '\\"') + '"]');
      var src = lab || el;
      var vis = src.querySelector ? src.querySelector('[aria-hidden="true"]:not(svg):not(.icon)') : null;
      var t = txt(vis && txt(vis.textContent) ? vis.textContent : defLabel(src));
      return txt(t.replace(/\s*\(\d[^)]*\)/g, ''));
    }

    /* ---------- option helpers (colour, size, other variant options) ---------- */
    function controlOf(el) {
      if (el.tagName === 'INPUT') return el;
      if (el.tagName === 'LABEL') {
        if (el.control) return el.control;
        var f = el.getAttribute('for');
        if (f) return document.getElementById(f);
        return el.querySelector('input');
      }
      return null;
    }
    function optName(el) {
      var inp = controlOf(el);
      var n = inp && inp.getAttribute ? inp.getAttribute('data-option-name') : '';
      if (n) return txt(n);
      var fs = el.closest ? el.closest('fieldset, .product-form__input') : null;
      if (!fs) return '';
      var lg = fs.querySelector('legend, label.form__label');
      if (!lg) return '';
      var out = '';
      for (var i = 0; i < lg.childNodes.length; i++) {
        var c = lg.childNodes[i];
        if (c.nodeType === 3) out += c.textContent;
        else if (txt(out)) break;
      }
      return txt(out).replace(/:\s*$/, '');
    }
    function optArea(el) {
      var n = optName(el);
      if (/^size/i.test(n)) return 'pdp_size';
      if (/colou?r/i.test(n)) return 'pdp_colour';
      return 'pdp_option';
    }
    function optLabel(el) {
      var inp = controlOf(el);
      var n = optName(el);
      var v = inp ? inp.value : '';
      if (el.tagName === 'SELECT') v = '';
      return (n ? n + ': ' : '') + v;
    }

    /* ---------- the selector map: ORDER MATTERS (first match on the nearest element wins) ---------- */
    /* [area (string or function), selector, label function (optional)] */
    var MAP = [
      /* cart drawer and cart page */
      ['cart_checkout', '#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"], #checkout'],
      ['cart_qty', 'cart-drawer .quantity__button, cart-drawer-items .quantity__button, cart-items .quantity__button, .cart-item .quantity__button, .wtf-line .quantity__button', function (el) { return el.getAttribute('name') || 'qty'; }],
      ['cart_remove', 'cart-remove-button, .cart-remove-button', function () { return 'remove'; }],
      ['cart_upsell', '[data-wtf-kind], [data-wtf-up-add], [data-wtf-up-prev], [data-wtf-up-next], .wtf-up a, .wtf-up button, .wtf-cart-recs a, .wtf-cart-recs button', function (el) {
        var k = el.getAttribute('data-wtf-kind') || '';
        return (k ? k + ': ' : '') + defLabel(el);
      }],
      ['cart_offer', '.wtf-d2-offer a, .wtf-d2-offer button, .wtf-ladder-card a, .wtf-ladder-card button, .wtf-b2g1-bar a, .wtf-b2g1-bar button, .wtf-signup-card a, .wtf-signup-card button, .wtf-signup-row a, .wtf-signup-row button, .wtf-d2-gift summary, .wtf-d2-save a'],
      ['cart_close', '.drawer__close, cart-drawer .button-close'],
      ['cart_item_link', '.wtf-line a, .cart-item a'],
      ['cart_drawer', 'cart-drawer a, cart-drawer button, cart-drawer summary'],
      ['cart_icon', '#cart-icon-bubble, .header__icon--cart', function () { return 'Cart'; }],

      /* popups */
      ['popup', '[class*="wtf-b2g1__"] a, [class*="wtf-b2g1__"] button, [class*="wtffs"] a, [class*="wtffs"] button, [class*="wtf-ff-a03-popup"] a, [class*="wtf-ff-a03-popup"] button'],

      /* header */
      ['localization', 'localization-form a, localization-form button, .localization-form a, .localization-form button, .disclosure a, .disclosure button'],
      ['skip_link', 'a.skip-to-content-link'],
      ['announcement_bar', '.announcement-bar a, .announcement-bar button'],
      ['search_result', 'predictive-search a, .predictive-search a, .predictive-search__item a'],
      ['search_submit', '.search-modal .search__button, .search-modal button[type="submit"]'],
      ['search', '.header__search summary, details-modal.header__search summary, .header__icon--search, .search-modal__close-button, .search-modal .reset__button'],
      ['menu_drawer_toggle', 'summary.header__icon--menu, .header__icon--menu', function () { return 'Menu'; }],
      ['menu_drawer', '.menu-drawer a, .menu-drawer summary, .menu-drawer button'],
      ['header_menu', '.header__inline-menu a, .header__inline-menu summary, .header__submenu a, .mega-menu__link, .mega-menu a'],
      ['logo', '.header__heading-link, .header__heading a'],
      ['account', 'shopify-account, .header__icon--account'],
      ['breadcrumb', '.wtf-crumb-bar a, .breadcrumb a'],

      /* sticky and size sheet on the product page (before the plain Add to cart) */
      ['pdp_sticky_add_to_cart', '.wtf-ff-sticky-atc__btn, .wtf-ff-sticky-atc button'],
      ['pdp_size_sheet_add', '.wtf-sheet__add'],
      ['pdp_size_sheet_option', '.wtf-sheet__opt'],
      ['pdp_size_chart', '.wtf-sheet__chart, [data-wtf-ff-sizechart-open], .wtf-ff-sizechart-trigger, .wtf-ff-sizechart-opener button'],
      ['pdp_size_sheet', '.wtf-sheet a, .wtf-sheet button'],
      ['pdp_find_my_size', '[data-wtf-sh-open], .wtf-sh-link'],
      ['pdp_size_dialog', '.wtf-ff-size-dialog a, .wtf-ff-size-dialog button'],

      /* collection page tools */
      ['collection_sort', 'select[name="sort_by"], .facet-filters__sort, #SortBy, #SortBy-mobile', function () { return 'Sort by'; }],
      ['collection_filter', 'facet-filters-form summary, facet-filters-form label, facet-filters-form input[type="checkbox"], facet-filters-form input[type="radio"], facet-filters-form a, facet-filters-form button, [class*="facets"] summary, [class*="facets"] label, [class*="facets"] input[type="checkbox"], [class*="facets"] input[type="radio"], [class*="facets"] a, [class*="facets"] button, facet-remove a, .active-facets a', function (el) {
        if (el.tagName === 'LABEL' || el.tagName === 'INPUT') return facetLabel(el);
        return txt(defLabel(el).replace(/\s*\(\d[^)]*\)/g, ''));
      }],
      ['pagination', '.pagination a, .pagination__item, [class*="load-more"] a, [class*="load-more"] button, [data-load-more]'],
      ['collection_chips', '.wtf-shop-more a'],
      ['collection_banner', '.collection-hero a, .collection-hero button, .wtf-coll-story a, .wtf-ff-coll-intro a, .wtf-mascot-coll-intro a, .wtf-ff-hero a, .wtf-ff-hero button, .wtf-mascot-hero a, .wtf-mascot-hero button, [class*="wtf-ff-grid"] a, [class*="wtf-mascot-grid"] a'],

      /* product cards */
      ['product_quick_add', '.quick-add button, .quick-add__submit, quick-add-modal button, quick-add-bulk button'],
      ['pdp_related', 'product-recommendations a, product-recommendations button, .related-products a, .related-products button'],
      ['product_card', '.card-wrapper a, .card-wrapper button, .product-card-wrapper a, .product-card-wrapper button'],

      /* product page */
      ['pdp_buy_now', 'shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button, .shopify-payment-button__button', function () { return 'Buy now'; }],
      ['pdp_add_to_cart', 'product-form button[name="add"], button.product-form__submit, form[action*="/cart/add"] button[type="submit"]'],
      [optArea, 'variant-selects fieldset label, variant-selects fieldset input, variant-selects select', optLabel],
      ['pdp_qty', '.quantity__button', function (el) { return el.getAttribute('name') || 'qty'; }],
      ['pdp_gallery', '.thumbnail-list button, .thumbnail, .thumbnail-slider button, media-gallery .slider-button, .product__media-toggle, .product__modal-opener, product-modal button, .product-media-modal button'],
      ['pdp_accordion', '.product__accordion summary, .accordion summary, .wtf-fit__summary, .wtf-fit summary'],
      ['cf_date_jump', 'a[data-wtf-cf-jump]', function () { return 'Personalized with your chosen date'; }],
      ['pdp_title_link', '.product__title a, .product__view-details'],
      ['pdp_backlink', '.wtf-ff-backlink-row a'],
      ['pdp_bundle_offer', '[data-wtf-hdu] a, .wtf-hdu a, .wtf-hdb a'],
      ['pdp_share', '.wtf-share-save button, .wtf-share-save a'],
      ['pdp_below', '.wtf-ff-pdp-below a, .wtf-ff-pdp-below button, .wtf-ff-pdp-below summary'],
      ['pdp_reviews', '[class*="jdgm"] a, [class*="jdgm"] button, [class*="jdgm-prev-badge"], .jm-frame, [class*="jm-"] a, [class*="jm-"] button'],

      /* home page */
      ['home_hero', '.wtf-hero a, .wtf-hero button'],
      ['home_banner', 'slideshow-component a, .slideshow a, .banner a, .banner__buttons a, .banner__box a, .image-banner a'],
      ['home_category', '.wtf-category-grid a, .cat-card'],
      ['home_best_sellers', '.wtf-bs a'],
      ['home_reviews', '.wtf-rev a, .wtf-rev button, .wtf-pr a, .wtf-pr button'],
      ['home_founder', '.wtf-founder a'],
      ['home_trust', '.wtf-trust a'],
      ['home_email_signup', '.wtf-email button, .wtf-email a'],

      /* footer and sign-up */
      ['newsletter_signup', '.newsletter button, .newsletter a, .newsletter-form button'],
      ['footer', 'footer a, footer button, footer summary, .footer a, .footer button'],

      ['policy_link', 'a[href*="/policies/"]'],

      /* rewards and chat launchers (third party) */
      ['rewards_page', '.wtf-rw a, .wtf-rw__btn'],
      ['rewards_launcher', '#smile-ui-lite-launcher-frame-container, #smile-ui-container, [id^="smile-ui"], [class*="smile-launcher"]', function () { return 'Rewards launcher'; }],
      ['hub_launcher', '.kl-hub-launcher-container, [class*="kl-hub"]', function () { return 'Hub launcher'; }]
    ];
    var OTHER = ['other', null];
    var FALLBACK = 'a[href], button, summary, [role="button"], [role="link"], input[type="submit"], input[type="button"]';
    /* Never track: typed fields, the Cancer-Free date pickers (tracked by wtf-cancer-free-date.js), personalization fields, cart note and gift message. */
    var SKIP = '[data-wtf-cf-date], .wtf-cf-date, [data-wtf-cf-select], [data-wtf-teams] input, [data-wtf-teams] select, [data-wtf-teams] textarea, input[type="text"], input[type="email"], input[type="tel"], input[type="password"], input[type="search"], input[type="number"], input[type="date"], input[type="url"], textarea, #CartDrawer-Note, #CartDrawer-GiftMessage, .field__input';

    /* ---------- page facts ---------- */
    function pageType() {
      try {
        var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
        var p = m && m.page && m.page.pageType;
        if (p) return String(p);
      } catch (e) { /* fall through */ }
      try {
        var b = document.body && document.body.getAttribute('data-page-type');
        if (b) return b;
        var main = document.querySelector('main[data-template]');
        if (main && main.getAttribute('data-template')) return main.getAttribute('data-template');
      } catch (e2) { /* ignore */ }
      return '';
    }
    function productHandle() {
      try {
        var m = /\/products\/([^\/?#]+)/i.exec(location.pathname);
        return m ? decodeURIComponent(m[1]).slice(0, 255) : '';
      } catch (e) { return ''; }
    }
    function hrefPath(el) {
      try {
        var a = el.closest ? el.closest('a[href]') : null;
        if (!a) return '';
        var raw = a.getAttribute('href') || '';
        if (/^(mailto|tel|sms):/i.test(raw)) return raw.split(':')[0] + ':';
        var u = new URL(a.href, location.href);
        if (u.origin !== location.origin) return u.hostname + u.pathname;
        return u.pathname;
      } catch (e) { return ''; }
    }

    /* ---------- resolve a click to { area, el, label } ---------- */
    function resolve(target) {
      if (target && target.nodeType !== 1) target = target.parentElement;
      if (!target || !target.matches) return null;
      if (target.closest(SKIP)) return null;
      var el = target;
      var depth = 0;
      while (el && el.nodeType === 1 && depth < 40) {
        for (var i = 0; i < MAP.length; i++) {
          if (el.matches(MAP[i][1])) return { el: el, entry: MAP[i] };
        }
        el = el.parentElement;
        depth++;
      }
      var f = target.closest(FALLBACK);
      return f ? { el: f, entry: OTHER } : null;
    }

    /* ---------- sending ---------- */
    function ensureWrap() { /* defined below */ }
    function send(p) {
      try {
        ensureWrap();
        internalPublish = true;
        try {
          var S = window.Shopify;
          if (S && S.analytics && typeof S.analytics.publish === 'function') S.analytics.publish('wtf_click', p);
        } catch (e) { /* a failing publish must not stop Clarity */ }
        internalPublish = false;
        try {
          if (typeof window.clarity === 'function') window.clarity('event', 'click_' + p.area);
        } catch (e2) { /* ignore */ }
      } catch (e3) { internalPublish = false; }
    }
    function record(area, label, hrefp) {
      var key = area + '|' + label + '|' + hrefp;
      var now = Date.now();
      if (key === lastKey && now - lastAt < DUP_MS) return;
      lastKey = key;
      lastAt = now;
      var p = { area: area, label: label, href: hrefp, page_type: pageType() };
      var h = productHandle();
      if (h && /product/i.test(p.page_type || 'product')) p.product_handle = h;
      send(p);
    }

    function onClick(e) {
      try {
        if (e.isTrusted === false) {
          /* Test hook only: a test may allow its own dispatched clicks. Nothing on the live site sets it. */
          var allow = window.__WTF_CT_ALLOW_SYNTHETIC;
          if (!(typeof allow === 'function' ? allow(e) : allow)) return;
        }
        var now = Date.now();
        var tgt = e.target && e.target.nodeType !== 1 ? e.target.parentElement : e.target;
        /* A click on a label makes the browser fire a second click on its checkbox / radio. Count the label click only. */
        if (tgt && lastCtl && tgt === lastCtl && now - lastCtlAt < LABEL_MS) { lastCtl = null; return; }
        var lab = tgt && tgt.closest ? tgt.closest('label') : null;
        if (lab) {
          var ctl = lab.control || (lab.querySelector ? lab.querySelector('input') : null);
          if (ctl) { lastCtl = ctl; lastCtlAt = now; }
        }
        var r = resolve(e.target);
        if (!r) return;
        var entry = r.entry;
        var area = entry[0];
        if (typeof area === 'function') area = area(r.el);
        var label = entry[2] ? entry[2](r.el) : defLabel(r.el);
        record(area, scrub(label), hrefPath(r.el));
      } catch (err) { /* never break the page */ }
    }
    document.addEventListener('click', onClick, { capture: true, passive: true });

    /* Third-party launchers draw inside an iframe, so no click reaches the page. The page window loses focus to the iframe instead. */
    window.addEventListener('blur', function () {
      try {
        window.setTimeout(function () {
          try {
            var ae = document.activeElement;
            if (!ae || ae.tagName !== 'IFRAME') return;
            var box = ae.closest ? ae.closest('#smile-ui-lite-launcher-frame-container, #smile-ui-container, [id^="smile-ui"], [class*="smile-launcher"], .kl-hub-launcher-container, [class*="kl-hub"]') : null;
            var id = (ae.id || '') + ' ' + (ae.title || '') + ' ' + (ae.name || '');
            if (box && /kl-hub/.test((box.className || '') + '')) record('hub_launcher', 'Hub launcher', '');
            else if (box || /smile/i.test(id)) record('rewards_launcher', 'Rewards launcher', '');
          } catch (e1) { /* ignore */ }
        }, 0);
      } catch (e2) { /* ignore */ }
    }, { passive: true });

    /* ---------- forward wtf_* events to Clarity: wrap Shopify.analytics.publish ONCE ---------- */
    /* Plain wrap, no accessor: a script that wraps publish after us cannot create a loop. A nested wrapper (ours inside theirs, or the reverse)
       forwards only once, because only the outermost call (fwdDepth 0) forwards. If Shopify later assigns its real publish function, the next
       ensureWrap() call (page load, first click, first change event) wraps that one instead. */
    var wrapped = false;
    var fwdDepth = 0;
    ensureWrap = function () {
      try {
        var S = window.Shopify;
        var A = S && S.analytics;
        if (!A) return false;
        var cur = A.publish;
        if (cur && cur.__wtfWrapper) { wrapped = true; return true; }
        if (typeof cur !== 'function') return false;
        var inner = cur;
        var wrapper = function (name) {
          var outer = fwdDepth === 0;
          try {
            if (outer && !internalPublish && typeof name === 'string' && name.indexOf('wtf_') === 0 && typeof window.clarity === 'function') {
              window.clarity('event', name);
            }
          } catch (e) { /* ignore */ }
          fwdDepth++;
          try { return inner.apply(this, arguments); } finally { fwdDepth--; }
        };
        wrapper.__wtfWrapper = true;
        A.publish = wrapper;
        wrapped = A.publish === wrapper;
        return wrapped;
      } catch (e2) { return false; }
    };
    ensureWrap();
    if (!wrapped) {
      document.addEventListener('DOMContentLoaded', ensureWrap, { once: true });
      window.addEventListener('load', ensureWrap, { once: true });
      window.setTimeout(ensureWrap, 1500);
      window.setTimeout(ensureWrap, 4000);
    }
    /* The date events fire on change. Re-check the wrap there in case Shopify replaced the analytics object. */
    document.addEventListener('change', function () { ensureWrap(); }, { capture: true, passive: true });
    window.addEventListener('load', function () { ensureWrap(); }, { once: true });

    /* ---------- page type to Clarity ---------- */
    function setPageType() {
      try {
        if (typeof window.clarity === 'function') {
          var pt = pageType();
          if (pt) window.clarity('set', 'page_type', pt);
        }
      } catch (e) { /* ignore */ }
    }
    setPageType();
  } catch (fatal) { /* never break the page */ }
})();
